import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Label } from 'reactstrap';
import 'rmc-picker/assets/index.css';
import 'react-dates/initialize';
import { DateRangePicker, ICON_AFTER_POSITION } from "react-dates";
import CalendarImage from '../../../components/CalendarImage';
import moment from 'moment';
import { isAfterDay } from '../../../../../utils/momentFunctions'

function InputRangeDate({ xs, sm, md, lg, xl, className, title, noTitle, startDatePlaceholder, endDatePlaceholder, startDateId, endDateId, startDate, endDate, onChangeStart, onChangeEnd, dateFormat = "YYYY-MM-DD", disabled, required, error, isDayBlocked = () => false, isOutsideRange = () => false }) {

    const changeDate = ({ startDate, endDate }) => {
        startDate ? onChangeStart(startDate.format(dateFormat)) : onChangeStart(null);
        endDate ? onChangeEnd(endDate.format(dateFormat)) : onChangeEnd(null);
      }

    const [focused, setFocused] = useState(null);

    const showClose = !!(startDate || endDate) && !disabled;
    
    return (
        <Col 
            xs={xs || 'auto'}
            sm={sm || 'auto'}
            md={md || 'auto'}
            lg={lg || 'auto'}
            xl={xl || 'auto'}
            className={`${error ? 'mb-1' : 'mb-4'} w-100 ${className ? className : ''}`}
        >
            <div className='w-100'>
                {title ? <Label>{title}{required ? <span className="label-danger">{' *'}</span> : ""}</Label> : noTitle ? "" : <Label className="hide-item">empty</Label>}
                <DateRangePicker
                    startDatePlaceholderText={startDatePlaceholder || "Data inicial"}
                    startDate={startDate ? moment(startDate) : null}
                    startDateId={startDateId ? startDateId : "startDateId"}
                    endDatePlaceholderText={endDatePlaceholder || "Data final"}
                    endDate={endDate ? moment(endDate) : null}
                    endDateId={endDateId ? endDateId : "endDateId"}
                    onDatesChange={changeDate}
                    focusedInput={focused}
                    onFocusChange={focused => { setFocused(focused); if (focused) document.activeElement.blur() }}
                    hideKeyboardShortcutsPanel={true}
                    isDayBlocked={isDayBlocked}
                    isOutsideRange={isOutsideRange}
                    numberOfMonths={1}
                    openDirection="down"
                    displayFormat="DD MMM, YYYY"
                    customArrowIcon="-"
                    customInputIcon={!showClose ? <CalendarImage /> : null}
                    showClearDates={showClose}
                    inputIconPosition={ICON_AFTER_POSITION}
                    disabled={disabled}
                    minimumNights={0}
                />
                {error ? <Label className="label-danger">{error}</Label> : <Label className="hide-item">empty</Label>}
            </div>
        </Col>
    )
}

InputRangeDate.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
    noTitle: PropTypes.bool,
    startDatePlaceholder: PropTypes.string, 
    endDatePlaceholder: PropTypes.string,
    startDateId: PropTypes.string,
    endDateId: PropTypes.string,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    onChangeStart: PropTypes.func.isRequired,
    onChangeEnd: PropTypes.func.isRequired,
    dateFormat: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    error: PropTypes.string,
    isDayBlocked: PropTypes.func,
    isOutsideRange: PropTypes.func

}

export default InputRangeDate


// WEBPACK FOOTER //
// ./src/modules/comum/tables/components/inputs/InputRangeDate.js